import { defineSetting } from './settingsRegistry';

declare module './settingsRegistry' {
  interface Settings {
    /** Frames-per-second meter (main.ts). */
    showFps: boolean;
  }
}

defineSetting({ key: 'showFps', default: false, order: 110, menu: { group: 'visual', label: 'แสดง FPS' } });
